<div class="popup-container tlms-popup">
    <header>
        <div class="header" style="display:block">{{heading}}</div>
        <button class="close" style="top:-3px" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <ng-container>
        <div style="padding: 16px 24px 16px 24px;">
            <div class="col-12" style="width: 100%;">
                <div class="body">
                    <div>
                        <label class="catlabel"> Shipment ID:</label>
                        <input type="text" class="category" [(ngModel)]="shipmentId" [disabled]="true">
                    </div>
                    <div>
                        <label class="catlabel">Supplier:<span style="color:#ff0000">*</span></label>
                        <select class="F1" id="category-drop-down" class="drpDown" [(ngModel)]="supplier">
                            <option [value]="supp.supplier" *ngFor="let supp of supplierDropdown">
                                {{supp.supplier}}</option>
                        </select>
                    </div>
                    <div>
                        <label class="catlabel">Shipment Type:<span style="color:#ff0000">*</span></label>
                        <select class="F1" id="category-drop-down" class="drpDown" [(ngModel)]="shipmentType">
                            <option [value]="shipmentType.shipmentTypeId"
                                *ngFor="let shipmentType of shipmentTypeDropDown">{{shipmentType.description}}
                            </option>
                        </select>
                    </div>
                    <div>
                        <label class="catlabel">Shipment Date:<span style="color:#ff0000">*</span></label>
                        <input type="date" style="margin-right: 0%;" [(ngModel)]="shipmentDate">
                    </div>
                    <div>
                        <label class="catlabel">Empty Packaging KG:</label>
                        <input type="text" [(ngModel)]="emptypackagingKG" (keyup)="(validate($event,'kg'))"
                            (keypress)="keyPressAlphaNumeric($event)">
                    </div>
                    <div>
                        <label class="catlabel">Empty Packaging Value:</label>
                        <input type="text" [(ngModel)]="emptypackagingValue" (keyup)="(validate($event,'value'))"
                            (keypress)="keyPressAlphaNumeric($event)">
                    </div>
                </div>
                <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
            </div>
        </div>
        <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
            <button (click)="onNoClick()" class="mCancel"> CANCEL
            </button>
            <button class="black-btn" style="display: inline" (click)="saveClick()">
                SAVE
            </button>
        </div>
    </ng-container>
</div>